import { TransactionType } from '../proto/generated/order'
import { OrderBook } from '../proto/generated/security'

/**
 * Limit-order price in the same scale as order-book quotes and `TradeOrder.price`
 * (typically raw tick × multiplier). Uses top ask for buy and top bid for sell;
 * if that side is missing or zero, falls back to order book LTP, then snapshot LTP.
 */
export function limitPriceFromOrderBookOrLtp(
    orderBook: OrderBook | undefined,
    transactionType: TransactionType,
    snapshotLastTradedPrice?: number
): number {
    const isBuy = transactionType === TransactionType.BUY
    const sidePrice = isBuy ? orderBook?.asks?.[0]?.price : orderBook?.bids?.[0]?.price
    if (sidePrice != null && sidePrice > 0) return sidePrice
    const bookLtp = orderBook?.lastTradedPrice ?? 0
    if (bookLtp > 0) return bookLtp
    const snapLtp = snapshotLastTradedPrice ?? 0
    if (snapLtp > 0) return snapLtp
    return 0
}
